import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale, Filler } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { formatTooltipTitle, formatTooltipLabel, formatTime } from '../../helpers';
import 'chartjs-adapter-date-fns';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale, Filler);

const LineChart = ({ chartData }) => {
	const chartOptions = {
		responsive: true,
		scales: {
			x: {
				type: 'time',
				time: {
					unit: 'month',
				},
				grid: {
					display: false,
				},
				ticks: {
					beginAtZero: true,
					padding: 10,
					font: {
						family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
						size: 14,
					},
				},
			},
			y: {
				ticks: {
					stepSize: 500,
					beginAtZero: false,
					padding: 10,
					font: {
						family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
						size: 14,
					},
					callback: value => {
						return formatTime(value);
					},
				},
			},
		},
		plugins: {
			tooltip: {
				yAlign: 'bottom',
				displayColors: false,
				callbacks: {
					title: formatTooltipTitle,
					label: formatTooltipLabel,
				},
				titleFont: {
					font: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
					size: 14,
					weight: 'normal',
				},
				titleMarginBottom: 0,
				padding: 10,
				cornerRadius: 8,
			},
			legend: {
				display: false,
			},
		},
	};
	return <Line data={chartData} options={chartOptions} />;
};

export default LineChart;
